import {confirmActionCancel} from 'actions/commonActions';
import AppIcon from 'components/common/AppIcon/AppIcon';
import AppPage from 'components/common/AppPage';
import Confirm from 'components/common/Confirm';
import {
  CONFIRMED_USER_STATUS,
  INACTIVE_USER_STATUS,
  PENDING_USER_STATUS,
  SUSPENDED_USER_STATUS
} from 'constants/userStatuses';
import _ from 'lodash';
import {rgba} from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import styled from 'styled-components';
import 'styles/App.scss';
import {colors} from 'styles/shared';

const UiBlock = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: ${rgba('black', 0.3)};
  filter: alpha(opacity=30);
  z-index: 999;
`;

const GlobalOverlayContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

App.propTypes = {
  routes: PropTypes.array.isRequired
};

function App(props) {
  let dispatch = useDispatch();

  const asyncAction = useSelector((state: any) => state.common.asyncAction);
  const confirmAction = useSelector((state: any) => state.common.confirmAction);
  const user = useSelector((state: any) => state.user.current);

  const cancelAction = () => {
    dispatch(confirmActionCancel());
  };

  let showOverlay = _.get(asyncAction, 'showOverlay', false);

  const renderRoute = (route, index: number) => {
    const {pageProps, component: Component} = route;

    const hideNavigation = pageProps.hideNavigation;

    //Apaprently I can't just set status !== ACTIVE_USER_STATUS since the user is undefined at this point
    const hideFromStatus = [CONFIRMED_USER_STATUS, INACTIVE_USER_STATUS, SUSPENDED_USER_STATUS, PENDING_USER_STATUS];

    if (!user?.isAdmin && pageProps.adminOnly) return null;
    if (hideFromStatus.includes(user?.status) && hideNavigation) return null;

    let wrapInAppPage = !_.isEmpty(pageProps);

    let render = props => <Component {...props} />;

    if (wrapInAppPage) {
      render = props => (
        <AppPage {...pageProps}>
          <Component {...props} />
        </AppPage>
      );
    }

    return <Route key={index} exact={route.exact} path={route.path} render={render} />;
  };

  return (
    <div>
      {showOverlay && (
        <UiBlock>
          <GlobalOverlayContent>
            <AppIcon name="loading" size="10x" color={colors.blue_main} spin />
          </GlobalOverlayContent>
        </UiBlock>
      )}

      {confirmAction && (
        <Confirm
          title={confirmAction.title}
          text={confirmAction.text}
          visible={true}
          action={async () => {
            cancelAction();
            await confirmAction.action();
          }}
          close={async () => {
            cancelAction();
            if (confirmAction.close) await confirmAction.close();
          }}
        />
      )}

      <Switch>{props.routes.map((route, index: number) => renderRoute(route, index))}</Switch>

      {props.children}
    </div>
  );
}

export default App;
